import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Reoccurring from "./Reoccurring";
import "../Time.scss";

export default function Time({
  startDate,
  startTime,
  endDate,
  endTime,
  onChange,
  setOccurrencesList
}) {
  const frequency = [
    { label: "varje vecka", value: "varje vecka" },
    { label: "varannan vecka", value: "varannan vecka" },
    { label: "varje månad", value: "varje månad" }
  ];
  const monthSpecs = [
    { label: "samma datum", value: "samma datum" },
    { label: "samma veckodag", value: "samma veckodag" }
  ];
  const [selected, setSelected] = useState(frequency[0].value);
  const [selectedMonthSpec, setSelectedMonthSpec] = useState(
    monthSpecs[0].value
  );
  const [finalDate, setFinalDate] = useState(
    startDate ? startDate : new Date().toLocaleString()
  );
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (isChecked) {
      if (selected === "varje vecka" || selected === "varannan vecka") {
        setDateListByWeeks(
          startDate,
          endDate,
          finalDate,
          selected === "varje vecka" ? 7 : 14
        );
      } else if (selected === "varje månad") {
        if (selectedMonthSpec === "samma datum") {
          setDateListByMonths(startDate, endDate, finalDate);
        } else if (selectedMonthSpec === "samma veckodag") {
          setDateListByMonthWeekday(startDate, endDate, finalDate);
        }
      }
    }
  }, [selected, selectedMonthSpec, finalDate, isChecked]);

  function setDateListByWeeks(startDate, endDate, finalDate, interval) {
    const dateList = [];
    let currentStartDate = new Date(startDate);
    const lastDate = new Date(finalDate);
    let currentEndDate = new Date(endDate);
    currentStartDate.setDate(currentStartDate.getDate() + interval);
    currentEndDate.setDate(currentEndDate.getDate() + interval);
    while (currentStartDate <= lastDate) {
      dateList.push({
        startdate: new Date(currentStartDate).toLocaleString().substring(0, 10),
        enddate: new Date(currentEndDate).toLocaleString().substring(0, 10)
      });
      currentStartDate.setDate(currentStartDate.getDate() + interval);
      currentEndDate.setDate(currentEndDate.getDate() + interval);
    }

    console.log(dateList);
    setOccurrencesList(dateList);
  }

  function setDateListByMonths(startDate, endDate, finalDate) {
    const dateList = [];
    let currentStartDate = new Date(startDate);
    const lastDate = new Date(finalDate);
    let currentEndDate = new Date(endDate);
    currentStartDate.setMonth(currentStartDate.getMonth() + 1);
    currentEndDate.setMonth(currentEndDate.getMonth() + 1);
    while (currentStartDate <= lastDate) {
      dateList.push({
        startdate: new Date(currentStartDate).toLocaleDateString(),
        enddate: new Date(currentEndDate).toLocaleDateString()
      });

      currentStartDate.setMonth(currentStartDate.getMonth() + 1);
      currentEndDate.setMonth(currentEndDate.getMonth() + 1);
    }

    console.log(dateList);
    setOccurrencesList(dateList);
  }

  function setDateListByMonthWeekday(startDate, endDate, finalDate) {
    const dateList = [];
    let currentStartDate = new Date(startDate);
    const lastDate = new Date(finalDate);
    let currentEndDate = new Date(endDate);
    const targetWeekday = currentStartDate.getDay();
    const targetOccurrence = Math.ceil(currentStartDate.getDate() / 7);

    while (currentStartDate <= lastDate) {
      // Find the target occurrence of the target weekday in the current month
      // This will not be accurate when I want to choose the last occurrence of the weekday of the month 
      // (sometimes the fourth on is the last on, sometimes its the fifth one...)
      let occurrenceCount = 0;
      currentStartDate.setDate(1); // Start from the first day of the month
      while (occurrenceCount < targetOccurrence) {
        if (currentStartDate.getDay() === targetWeekday) {
          occurrenceCount++;
        }
        if (occurrenceCount < targetOccurrence) {
          currentStartDate.setDate(currentStartDate.getDate() + 1);
        }
      }

      dateList.push({
        startdate: new Date(currentStartDate).toLocaleDateString(),
        enddate: new Date(currentEndDate).toLocaleDateString()
      });

      // Move to the next month
      currentStartDate.setMonth(currentStartDate.getMonth() + 1);
      currentEndDate.setMonth(currentEndDate.getMonth() + 1);
    }

    console.log(dateList);
    setOccurrencesList(dateList);
  }

  function handleSetSelected(e) {
    setSelected(e.value);
  }

  function handleSetSelectedMonthSpec(e) {
    setSelectedMonthSpec(e.value);
  }

  function handleSetFinalDate(e) {
    setFinalDate(e.target.value);
  }

  return (
    <>
      <div className="time">
          <span className="start-date-label">*Startdatum</span>
          <input className="start-date"
            type="date"
            name="startdate"
            defaultValue={
              startDate
                ? startDate.substring(0, 10)
                : new Date().toLocaleString().substring(0, 10)
            }
            onChange={onChange}
          ></input>
          <span className="start-time-label"> *Starttid</span>
          <input className="start-time"
            type="time"
            name="starttime"
            defaultValue={
              startTime
                ? startTime.substring(0, 5)
                : new Date().toLocaleString().substring(11, 16)
            }
            onChange={onChange}
          />
          <span className="end-date-label">Slutdatum</span>
          <input className="end-date"
            type="date"
            name="enddate"
            min={startDate}
            defaultValue={
              endDate
                ? endDate.substring(0, 10)
                : new Date().toLocaleString().substring(0, 10)
            }
            onChange={onChange}
          ></input>
          <span className="end-time-label">Sluttid</span>
          <input className="end-time"
            type="time"
            name="endtime"
            defaultValue={
              endTime
                ? endTime.substring(0, 5)
                : new Date().toLocaleString().substring(11, 16)
            }
            selected={endTime}
            onChange={onChange}
          />
      </div>
      <Reoccurring
        frequency={frequency}
        specs={monthSpecs}
        selected={selected}
        setSelected={handleSetSelected}
        selectedSpec={selectedMonthSpec}
        setSelectedSpec={handleSetSelectedMonthSpec}
        finalDate={new Date(startDate).toLocaleString()}
        setFinalDate={handleSetFinalDate}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
      />
    </>
  );
}

Time.propTypes = {
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  startTime: PropTypes.string,
  endDate: PropTypes.string,
  endTime: PropTypes.string,
  setOccurrencesList: PropTypes.func.isRequired
};
